"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _material = require("@mui/material");

var _Typography = require("../Typography");

var _utilities = require("../../utilities");

var _react = require("react");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["children", "isActive"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var StyledTypography = (0, _material.styled)(_Typography.Typography)(function (_ref) {
  var _ref2;

  var theme = _ref.theme;
  return _ref2 = {}, (0, _defineProperty2.default)(_ref2, "&.".concat(_utilities.classes.components.MuiTypography.root, " > *"), {
    marginLeft: theme.spacing(4)
  }), (0, _defineProperty2.default)(_ref2, "marginRight", theme.spacing(5)), (0, _defineProperty2.default)(_ref2, "textTransform", "uppercase"), _ref2;
});
var StyledLink = (0, _material.styled)(_material.Link, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== "isActive";
  }
})(function (_ref3) {
  var theme = _ref3.theme,
      isActive = _ref3.isActive;
  return {
    "&:hover": {
      color: theme.palette.primary.main
    },
    fontWeight: isActive ? "bold" : "normal"
  };
});

var NavLinks = function NavLinks(_ref4) {
  var _ref4$links = _ref4.links,
      links = _ref4$links === void 0 ? [] : _ref4$links;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledTypography, {
    variant: "body3",
    children: links.map(function (_ref5) {
      var children = _ref5.children,
          isActive = _ref5.isActive,
          rest = (0, _objectWithoutProperties2.default)(_ref5, _excluded);
      return /*#__PURE__*/(0, _react.createElement)(StyledLink, _objectSpread(_objectSpread({}, rest), {}, {
        color: isActive ? "textPrimary" : "textSecondary",
        isActive: isActive,
        key: rest.href
      }), children);
    })
  });
};

var _default = NavLinks;
exports.default = _default;